import './App.css';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';

function App() {
  const history = useHistory();
  const [userID, setUserID] = useState('');
  const [token, setToken] = useState('');
  const [clientId, setClientId] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'userID') {
      setUserID(value);
    } else if (name === 'token') {
      setToken(value);
    } else if (name === 'clientId') {
      setClientId(value);
    }
  };

  const redirect = () => {
    if (userID !== '' && token !== '') {
      const queryParams = new URLSearchParams({
        userID: userID,
        token: token,
        clientId: clientId,
      }).toString();

      history.push(`/preference?${queryParams}`);
    } else {
      alert('Enter userID and auth token properly');
    }
  };

  return (
    <div className="pref-form">
      <div className="field-wrapper">
        <label>User ID (*)</label>
        <input
          type="text"
          name="userID"
          value={userID}
          onChange={handleChange}
        />
      </div>
      <div className="field-wrapper">
        <label>Token (*)</label>
        <input
          type="text"
          name="token"
          value={token}
          onChange={handleChange}
        />
      </div>
      <div className="field-wrapper">
        <label>Client ID</label>
        <input
          type="text"
          name="clientId"
          value={clientId}
          onChange={handleChange}
        />
      </div>
      <button onClick={redirect}>Go Preference</button>
    </div>
  );
}

export default App;
